import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../../../shared/components/variables';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 6.462px;
  flex-wrap: wrap;
`;

export const MessageBodyContainer = styled(Box)`
  display: flex;
  padding: 4px;
  flex-direction: column;

  border-radius: 4px;
  background: ${colorTokens.surface.light};
`;
